import React from "react";
import classes from "./PrimaryButton.module.scss";
import { ReactComponent as RightArrow } from "../../assets/icon-arrow-right.svg";
import { locationCompanyProfile } from "../../features/helpers";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  mobile?: boolean;
  responsive?: boolean;
  center?: boolean;
  desktop?: boolean;
  disabled?: boolean;
  submit?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  callNow?: boolean;
  loading?: boolean;
}

function PrimaryButton(props: Props) {
  const responsiveClassName = props.mobile
    ? `${classes.mobile}`
    : props.responsive
    ? `${classes.responsive}`
    : `${classes.desktop}`;
  const buttonProps = {
    className: `${classes.button} ${responsiveClassName}`,
    disabled: props.disabled ? props.disabled : false,
    onClick: props.onClick ? props.onClick : undefined,
  };
  const companyProfile = locationCompanyProfile();
  const aProps = {
    href: props.callNow === true ? `tel:${companyProfile["phone-number"]}` : undefined,
  };

  return (
    <a {...aProps}>
      <button {...buttonProps} type={props.submit ? "submit" : "button"}>
        {props.children}
        {props.loading ? (
          <div className={classes.spinner} />
        ) : (
          <RightArrow style={{ marginLeft: "8px" }} />
        )}
      </button>
    </a>
  );
}

export default PrimaryButton;
